import { useLocalization, Tooltip } from '@magicdoorinc/ui';
import { A } from '@solidjs/router';
import { For } from 'solid-js';
import CopyIcon from '~/assets/images/common/iconCopy.svg?component-solid';
import PlanetIcon from '~/assets/images/quick-link/planet-icon.svg?component-solid';
import { createClipboard } from '~/utils/clipboard';

interface QuickLinksPanelProps {
  quickLinks: Array<{ name: string; href: string }>;
}

export const QuickLinksPanel = (props: QuickLinksPanelProps) => {
  const { t } = useLocalization();
  const { copy, tooltipMessage } = createClipboard({
    errorMessage: t('Failed to copy'),
    tooltipMessages: {
      default: t('Click to copy'),
      copied: t('Copied'),
    },
  });

  return (
    <div
      class="relative w-full rounded-lg border border-separator bg-white p-4 shadow-lg"
      style={{
        background: 'linear-gradient(360deg, #FFFFFF 0%, #C479FF 100%)',
      }}>
      <div class="mb-4 text-xl font-semibold text-white">{t('Quick links')}</div>
      <PlanetIcon class="absolute right-4 top-1" />
      <For each={props.quickLinks}>
        {(item) => (
          <div class="my-2 flex w-full items-center justify-between rounded-lg bg-gray-100 px-4 py-2">
            <div class="flex min-w-0 flex-1 flex-col text-sm">
              <p class="text-text-03">{item.name}</p>
              <A href={item.href} class="break-words text-primary hover-allowed:hover:underline" target="_blank">
                {item.href}
              </A>
            </div>
            <div class="flex items-center border-l pl-4">
              <Tooltip message={tooltipMessage()} class="cursor-pointer" align="top">
                <CopyIcon onClick={() => copy(item?.href || '')} class="text-text-03" />
              </Tooltip>
            </div>
          </div>
        )}
      </For>
    </div>
  );
};
